import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const uk: AppStrings = {
  // COMMON
  error_title: 'Помилка',
  cancel: 'Скасувати',
  retry: 'Повторити',
  back_arrow: '← Назад',

  // ASK SCREEN
  ask_box_unavailable: 'Скринька недоступна',
  ask_box_unavailable_desc: 'Схоже, посилання застаріло або автор закрив скриньку.',
  ask_create_own_box: 'Створити свою скриньку',
  ask_sent_title: 'Надіслано ✅',
  ask_sent_desc: 'Анонімне запитання дійшло до автора скриньки.',
  ask_anonymous_hint: 'Ваше запитання надійде анонімно.',
  ask_placeholder: 'Напишіть запитання…',
  ask_send: 'Надіслати',
  ask_sending: 'Надсилання…',
  ask_error_rate_limit: 'Занадто часто, зачекайте хвилину.',
  ask_error_restart: 'Перезапустіть Mini App.',
  ask_error_load: 'Не вдалося завантажити скриньку.',
  ask_error_send: 'Не вдалося надіслати запитання.',
  ask_error_banned: 'Вас заблоковано в застосунку.',
  ask_banned_appeal_btn: 'Оскаржити',
  ask_appeal_sent: 'Апеляцію надіслано. Ми розглянемо її вручну.',

  // AGE GATE
  age_gate_title: 'Тільки для 18+',
  age_gate_desc:
    'Ви надсилаєте анонімне запитання. Будьте поважливими: заборонені цькування, погрози, сексуальний контент щодо неповнолітніх та будь-який контент, що порушує закон. Анонімність не означає безкарність — порушення передаються на модерацію. Надсилаючи запитання, ви підтверджуєте, що вам є 18 років, і приймаєте правила.',
  age_gate_confirm: 'Мені є 18 — продовжити',

  // INBOX SCREEN
  inbox_title: 'Приймання запитань',
  box_link_accordion: 'Посилання для запрошень',
  inbox_notifications_ask: '🔔 Дозволити боту надсилати сповіщення про нові запитання?',
  inbox_notifications_allow: 'Дозволити',
  inbox_notifications_dismiss_label: 'Сховати',
  inbox_box_toggle_disable: 'Вимкнути приймання',
  inbox_box_toggle_enable: 'Увімкнути приймання',
  inbox_box_disabled_warning: 'Приймання запитань вимкнено — нові запитання не приймаються.',
  inbox_share_hint: 'Поділися посиланням — друзі зможуть поставити тобі анонімні запитання.',
  inbox_copy: 'Скопіювати',
  inbox_copied: 'Скопійовано',
  inbox_copy_error: 'Помилка',
  inbox_no_deeplink: 'Посилання з`явиться після deploy.',
  inbox_invite_story: 'Запросити через Story',
  inbox_invite_chat: 'Запросити через чат',
  inbox_card_rendering: 'Картка-запрошення ще рендериться.',
  inbox_story_unsupported:
    'Story недоступні в цій версії Telegram. Спробуй «через чат».',
  inbox_story_error: 'Не вдалося відкрити Story.',
  inbox_chat_unsupported:
    'Шеринг у чат недоступний у цій версії Telegram. Онови клієнт.',
  inbox_chat_error: 'Не вдалося поділитися. Спробуй ще раз.',
  inbox_chat_prepare_error: 'Не вдалося підготувати запрошення.',
  inbox_filter_incoming: 'Вхідні',
  inbox_filter_hidden: 'Приховані',
  inbox_filter_blocked: 'Бан',
  inbox_filter_empty: 'Тут поки порожньо.',
  inbox_acc_unanswered: 'Без відповіді',
  inbox_acc_answered: 'Відповіді надано',
  inbox_acc_hidden: 'Приховані',
  inbox_acc_blocked: 'Заблоковані',
  inbox_empty: 'Запитань поки немає. Поділися посиланням вище.',
  inbox_load_more: 'Завантажити ще',
  inbox_load_more_error: 'Не вдалося завантажити наступну сторінку.',
  inbox_error_load: 'Не вдалося завантажити скриньку.',
  inbox_rate_limit: 'Занадто часто, зачекайте хвилину.',
  inbox_toggle_error: 'Не вдалося змінити статус скриньки.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Напиши мені анонімно',
  message_placeholder: 'Напишіть повідомлення…',
  message_anonymous_hint: 'Ваше повідомлення надійде анонімно.',
  message_sent_title: 'Надіслано ✅',
  message_sent_desc: 'Ваше анонімне повідомлення доставлено.',
  message_owner_entry: 'Напиши мені',
  message_share_hint: 'Поділися посиланням — і будь-хто зможе надіслати тобі анонімне повідомлення.',
  message_inbox_open: 'Отримані повідомлення',
  message_inbox_title: 'Повідомлення',
  message_inbox_empty: 'Повідомлень поки немає. Поділися посиланням вище.',

  // ANSWER SCREEN
  answer_title: 'Відповідь на запитання',
  answer_placeholder: 'Напишіть відповідь…',
  answer_submit: 'Надіслати',
  answer_submitting: 'Надсилання…',
  answer_back: 'Назад',
  answer_error_send: 'Не вдалося надіслати відповідь.',

  // SHARE SCREEN
  share_title: 'Відповідь опубліковано ✅',
  share_hint: 'Поділися карткою і збери ще більше запитань.',
  share_card_rendering_desc:
    'Картка ще рендериться. Повернися до запитань і зазирни трохи пізніше — зможеш поділитися нею у Story або чаті.',
  share_card_alt: 'Картка відповіді',
  share_story_btn: 'Поділитися у Story',
  share_story_btn_busy: 'Відкриваю…',
  share_chat_btn: 'Поділитися у чат',
  share_chat_btn_busy: 'Готую…',
  share_back: 'Повернутися до запитань',
  share_story_unsupported:
    'Story недоступні в цій версії Telegram. Спробуй «Поділитися у чат».',
  share_story_error: 'Не вдалося відкрити Story. Спробуй «Поділитися у чат».',
  share_chat_sent: 'Повідомлення надіслано.',
  share_chat_unsupported:
    'Шеринг у чат недоступний у цій версії Telegram. Онови клієнт.',
  share_chat_error: 'Не вдалося поділитися. Спробуй ще раз.',
  share_chat_prepare_error: 'Не вдалося підготувати повідомлення.',

  // LEADERBOARD SCREEN
  lb_title: 'Лідерборд',
  lb_period_7d: '7 днів',
  lb_period_30d: '30 днів',
  lb_period_all: 'Весь час',
  lb_group_label: 'Категорія',
  lb_group_all: 'Усі',
  lb_group_ask: 'Запитання',
  lb_group_rate: 'Оцінки',
  lb_group_confession: 'Зізнання',
  lb_group_guesswho: 'Вгадай хто',
  lb_group_message: 'Повідомлення',
  lb_error: 'Не вдалося завантажити лідерборд',
  lb_empty: 'Поки нікого в рейтингу',
  lb_anon: 'Анонім',
  lb_load_more: 'Завантажити ще',
  lb_questions: (n) => `${n} зап.`,
  lb_referrals: (n) => `${n} реф.`,

  // REWARDS SCREEN
  rw_title: 'Мої нагороди',
  rw_error: 'Не вдалося завантажити нагороди',
  rw_level: (n) => `Рівень ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('uk', n, {
      one: '{n} підтверджений реферал',
      few: '{n} підтверджених реферали',
      many: '{n} підтверджених рефералів',
      other: '{n} підтверджених рефералів',
    }),
  rw_next_level_section: (n) =>
    plural('uk', n, {
      one: 'НАСТУПНИЙ РІВЕНЬ — {n} реферал',
      few: 'НАСТУПНИЙ РІВЕНЬ — {n} реферали',
      many: 'НАСТУПНИЙ РІВЕНЬ — {n} рефералів',
      other: 'НАСТУПНИЙ РІВЕНЬ — {n} рефералів',
    }),
  rw_to_level: (level, target) => `до рівня ${level}: ${target}`,
  rw_max_level: 'Максимальний рівень досягнуто!',
  rw_badges_section: 'БЕЙДЖІ',
  rw_formats_section: 'ФОРМАТИ СКРИНЬКИ',

  // QUESTION CARD
  qcard_status_new: 'Нове',
  qcard_status_hidden: 'Приховано',
  qcard_status_answered: 'Відповідь надано',
  qcard_moderation_flagged: 'Обережно, підозріле повідомлення',
  qcard_answer_btn: 'Відповісти',
  qcard_answer_send: 'Надіслати',
  qcard_share_btn: 'Поділитися',
  qcard_hide_btn: 'Сховати',
  qcard_show_btn: 'Показати',
  qcard_report_btn: 'Поскаржитися',
  qcard_block_btn: 'Заблокувати',
  qcard_unblock_btn: 'Розблокувати',
  qcard_report_reason_label: 'Оберіть причину скарги:',
  qcard_reason_spam: 'Спам',
  qcard_reason_harassment: 'Цькування',
  qcard_reason_sexual: 'Сексуальний контент',
  qcard_reason_other: 'Інше',
  qcard_error_hide: 'Не вдалося змінити видимість.',
  qcard_error_report: 'Не вдалося надіслати скаргу.',
  qcard_error_block: 'Не вдалося заблокувати відправника.',
  qcard_report_done: 'Скаргу надіслано — дякуємо.',
  qcard_block_done: 'Відправника заблоковано.',
  qcard_unblock_done: 'Відправника розблоковано.',

  // ERRORS
  err_network: 'Немає зв`язку з сервером. Перевірте інтернет і спробуйте знову.',
  err_server_unavailable: 'Сервер тимчасово недоступний, спробуйте пізніше.',
  err_internal: 'Щось пішло не так. Ми вже знаємо — спробуйте пізніше.',
  err_bad_request: 'Перевірте введені дані.',
  err_generic: 'Не вдалося виконати дію, спробуйте пізніше.',
  err_schema: 'Помилка даних. Спробуйте оновити застосунок.',
  share_story_link_premium_note:
    'Посилання у Story Telegram додає лише з Telegram Premium. Без нього друзі однаково знайдуть тебе — нік є на картці.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Помилка доступу',
  auth_error_desc:
    'Не вдалося авторизуватися. Будь ласка, закрийте і знову відкрийте Mini App через Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Нова нагорода!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Запитання',
  tab_leaderboard: 'Лідерборд',
  tab_rewards: 'Нагороди',
  tab_settings: 'Налаштування',

  // SETTINGS SCREEN
  settings_title: 'Налаштування',
  settings_section_general: 'Загальне',
  settings_notifications: 'Сповіщення про нові запитання',
  settings_notifications_hint: 'Бот надсилатиме повідомлення, коли тобі поставлять запитання.',
  settings_notifications_error: 'Не вдалося зберегти налаштування сповіщень.',
  settings_language: 'Мова',
  settings_language_error: 'Не вдалося змінити мову. Спробуй ще раз.',
  settings_section_about: 'Про застосунок',
  settings_version: 'Версія',

  // CODE ENTRY (work-020)
  code_modal_title: 'Посилання в сторіс — тільки для Premium',
  code_modal_explain:
    'Telegram дає клікабельне посилання в сторіс лише підписникам Premium. Але ви можете додати в сторіс свій код — глядачі введуть його в застосунку і поставлять вам анонімне запитання.',
  code_modal_your_code: 'Ваш код',
  code_modal_copy: 'Скопіювати код',
  code_modal_copied: 'Скопійовано',
  code_modal_share_btn: 'Поділитися в сторіс',
  code_modal_loading: 'Готуємо код…',
  code_modal_error: 'Не вдалося отримати код. Спробуйте пізніше.',
  ask_code_title: 'Введіть код',
  ask_code_desc:
    'Якщо ви перейшли зі сторіс — знайдіть у ній код (наприклад, 1234) і введіть нижче.',
  ask_code_placeholder: 'Код зі сторіс',
  ask_code_find: 'Знайти',
  ask_code_not_found: 'Код не знайдено. Перевірте цифри і спробуйте знову.',
  ask_code_invalid: 'Код складається з 4 цифр.',
  code_onboarding_header: 'Прийшли зі сторіс?',
  code_onboarding_text: 'Введіть код друга, щоб поставити йому анонімне запитання.',
  code_onboarding_action: 'Ввести код',
  settings_ask_by_code: 'Запитати за кодом',
  settings_my_code_title: 'Ваш код для сторіс',
  settings_my_code_hint:
    'Напишіть цей код у сторіс — глядачі введуть його, щоб поставити вам анонімне запитання. Клікабельне посилання в сторіс Telegram дає лише Premium-підписникам.',
  settings_my_code_rotate: 'Отримати новий код',
  settings_my_code_rotating: 'Змінюємо…',
  settings_my_code_done: 'Код оновлено',
  settings_my_code_error: 'Не вдалося отримати код.',
  settings_my_code_rotate_confirm_title: 'Змінити код?',
  settings_my_code_rotate_confirm_desc:
    'Старий код перестане працювати одразу. Ті, хто бачив його у вашій сторіс, більше не зможуть до вас написати. Змінюйте лише тоді, коли вам хтось набридає спамом.',
  settings_my_code_rotate_confirm_action: 'Змінити код',

  // BOT
  bot_greeting: (name) => (name ? `Привіт, ${name}! 👋` : 'Привіт! 👋'),
  bot_onboarding:
    'Це VeylMe — анонімні запитання.\n\n' +
    'Відкрий mini app, опублікуй картку «Постав мені анонімне запитання» у свою Story — ' +
    'і отримуй анонімні запитання прямо сюди.\n\n' +
    '⚠️ 18+. Будь поважним: травля, погрози і заборонений контент ' +
    'неприпустимі. Анонімність ≠ безкарність — порушення передаються модерації.',
  bot_open_btn: 'Відкрити VeylMe',
  notify_answer_btn: 'Відповісти',
  bot_invite_text:
    'Хтось поділився посиланням на VeylMe.\n\n' +
    'Відкрий mini app, щоб поставити анонімне запитання:',
  bot_invite_btn: 'Запитати анонімно',

  // WORK-027 i18n sweep
  tagline: 'Постав мені анонімне запитання',
  share_ask_action: 'Запитати',
  share_answered_text: 'Я відповів на анонімне запитання 👀',
  err_not_in_telegram: 'Mini App не запущено в Telegram. Перезапустіть застосунок.',
  badge_viral_starter: 'Вірусний старт',
  badge_storyteller: 'Оповідач',
  badge_loop_master: 'Майстер циклу',
  theme_confession: 'Зізнання',
  theme_guesswho: 'Вгадай хто',
  rw_format_named: (name) => `формат «${name}»`,
  card_label_question: 'Запитання',
  card_label_answer: 'Відповідь',
  card_invite_subtitle: 'анонімно, без реєстрації',
  card_code_hint: 'ВВЕДИ КОД У ЗАСТОСУНКУ',
  share_msg_title: (brand) => `${brand} · Анонімні запитання`,
  notify_new_question: '🔔 Вам поставили анонімне запитання',
  notify_unanswered_reminder: (n) =>
    plural('uk', n, {
      one: '🔔 У вас {n} запитання без відповіді',
      few: '🔔 У вас {n} запитання без відповіді',
      many: '🔔 У вас {n} запитань без відповіді',
      other: '🔔 У вас {n} запитань без відповіді',
    }),
  notify_ban_permanent: 'назавжди',
  notify_ban_until: (date) => `до ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Вас заблоковано в VeylMe ${untilPhrase}. Забагато отримувачів поскаржилися на ваші повідомлення.\nЯкщо вважаєте це помилкою — подайте апеляцію в застосунку.`,
  notify_warning_msg:
    '⚠️ Кілька отримувачів поскаржилися на ваші повідомлення. Ще трохи — і вас заблокують у VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Мої запитання',
  my_questions_empty_title: 'Ти ще не ставив запитань',
  my_questions_empty_desc: 'Постав запитання в чиюсь скриньку — відповідь з\'явиться тут.',
  my_questions_loading: 'Перевіряємо відповідь…',
  my_questions_waiting: 'Очікує відповіді',
  my_questions_answer_label: 'Відповідь',
  settings_my_questions: 'Мої запитання',
  ask_sent_find_reply_hint: 'Відповідь можна буде знайти пізніше у «Моїх запитаннях».',
  inbox_story_nonpremium_hint: 'Посилання в Story не клікабельне без Telegram Premium, тому показуємо код — надіслати в чат надійніше.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Перепустка Telegram застаріла',
  session_expired_desc: 'Telegram видає застосунку перепустку один раз під час запуску, і ця вже застаріла. Відкрийте застосунок заново — розпочатий текст ми зберегли.',
  session_expired_desc_no_storage: 'Пропуск Telegram застарів, застосунок потрібно відкрити заново. Зберегти введений текст не вдалося — скопіюйте його перед виходом.',
  session_expired_reopen: 'Відкрити заново',
  session_expired_stuck_title: 'Telegram видав ту саму стару перепустку',
  session_expired_stuck_desc: 'Закрийте застосунок повністю через меню бота й відкрийте знову — тоді Telegram видасть нову перепустку.',
  session_auth_failed_title: 'Не вдалося підтвердити вхід',
  session_auth_failed_desc: 'Telegram не підтвердив вхід у застосунок. Закрийте застосунок і відкрийте його заново з чату з ботом.',
  session_expired_manual_close: 'Закрити застосунок звідси не вийде — закрийте його самі й відкрийте заново з чату з ботом.',
  session_expiring_soon: 'Перепустка Telegram скоро завершиться. Відкрийте застосунок заново, щоб нічого не втратити.',
  my_questions_check_failed: 'Не вдалося перевірити відповіді. Спробуйте пізніше.',
  settings_notifications_load_error: 'Не вдалося завантажити налаштування.',
};
